import * as React from 'react';
import Icon, { ICON_STOPWATCH_LINE } from '~/components/icon';
import { HeadWrapper, MainTitle, SubTitle } from '~/components/misc/section-head.js';
import ButtonWrapper from '~/components/misc/button-wrapper.js';
import { ButtonProps, RCPopupProps } from '~/components/account/reality-check-new/utils/types';

const Button: React.FC<ButtonProps> = ({ onClick, dataAt, text, className }) => (
	<button type="button" className={`btn ${className ?? ''}`} onClick={onClick} data-at={dataAt}>
		{text}
	</button>
);

const RCPopup: React.FC<RCPopupProps> = ({ infoResponse, buttonConfig }) => {
	const formattedPlayedTime = `${infoResponse.playTimeHours} ${infoResponse.texts?.hours} ${infoResponse.playTimeMinutes} ${infoResponse.texts?.minutes}`;
	return (
		<div className="modal-view modal-view--fixed reality-check-modal">
			<div className="notify--is-open reality-check-confirm u-height-100">
				<HeadWrapper className="u-scroll-content-wrapper u-pb-xl2">
					<Icon type={ICON_STOPWATCH_LINE} />
					<MainTitle>{infoResponse.texts?.messageHeader}</MainTitle>
					<SubTitle>{infoResponse.texts?.messageUpper}</SubTitle>
					<div className="u-mt2">
						{infoResponse.texts?.cooldownPeriod && (
							<>
								<h3 className="reality-check__time-header u-result-header u-m0">
									{infoResponse.texts?.cooldownHeader}
								</h3>
								<h2 className="reality-check__time-result u-result">
									<span>{infoResponse.texts?.cooldownPeriod}</span>
								</h2>
							</>
						)}
						<h3 className="reality-check__sum-header u-result-header u-m0">
							{infoResponse.texts?.playedTime}
						</h3>
						<h2 className="reality-check__sum-result u-result">{formattedPlayedTime}</h2>

						<h3 className="reality-check__sum-header u-result-header u-m0">
							{infoResponse.texts?.betSumHeader}
						</h3>
						<h2 className="reality-check__sum-result u-result">{infoResponse.betSum}</h2>
					</div>
				</HeadWrapper>

				<ButtonWrapper pt={3} pb={3} transparent>
					{buttonConfig.map(config => (
						<Button key={config.dataAt} {...config} />
					))}
				</ButtonWrapper>
			</div>
		</div>
	);
};

export default RCPopup;
